import React from 'react';
import { Tooltip } from 'antd';
import { SafetyCertificateFilled } from '@ant-design/icons';

export default function AuditPassedMark({ sku, floating = true, style }) {
    if (floating && !sku?.auditPassed) return null;
    return (
        <div
            className="audit_passed_status"
            style={{
                ...(floating ? { position: 'absolute', left: '2px', bottom: '22px' } : {}),
                height: '25px',
                width: '25px',
                zIndex: 3,
                borderRadius: '50%',
                backgroundColor: '#1D4ED8',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid white',
                ...style,
            }}
        >
            <Tooltip title="Audit Passed">
                <SafetyCertificateFilled style={{ color: '#fff', fontSize: 14 }} />
            </Tooltip>
        </div>
    );
}
